import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "An engineer's view on philosophy",
  "description": "",
  "published": "2010-05-12T00:00:00.000Z",
  "redirect_from": ["/blog/an-engineers-view-on-philosophy/swizec/1333"],
  "categories": "Philosophers, Philosophy, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Aristotle_Altemps_Inv8575.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/05/300px-Aristotle_Altemps_Inv8575.jpg",
              "alt": "Bust of Aristotle. Marble, Roman copy after a ...",
              "title": "Bust of Aristotle. Marble, Roman copy after a ..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Aristotle_Altemps_Inv8575.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Disclaimer: I am writing this on my phone while walking to work`}</p>
    <p>{`Reading a `}<a parentName="p" {...{
        "href": "http://www.smbc-comics.com/index.php?db=comics&id=1879#comic"
      }}>{`funny comic on philosophy vs. engineering`}</a>{` and a short discourse on twitter has got me to thinking.`}</p>
    <p>{`Just why is there such a huge divide between engineers and philosophers?`}</p>
    <p>{`Because philosophers are annoying brats.`}</p>
    <p>{`Most of it comes from their general inability to actually think, that is to say, consider all the variables.`}</p>
    <p>{`For example, a philosopher will natter on and on about how a copy of a copy is an original and completely indistinguishable from the original and arguing that it is now magically impossible to tell which came first.`}</p>
    <p>{`All the while programmers have been copying variables left and right to good use and distinguishing them quite well for over 60 years.`}</p>
    <p>{`The philosophers still don't quite know whether a copy is an original or a copy.`}</p>
    <p>{`Now while I do think philosophy has made some marvelous contributions to our society - like inventing mathematics, most of the time it's just about being a colossal brat and regurgitating memorised thousands of years of actual thinking to look smart.`}</p>
    <p>{`Then again, like a guitar, a good way to impress chicks.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/4020dd1e-ac80-4db8-b431-2f8bff7b0eda/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=4020dd1e-ac80-4db8-b431-2f8bff7b0eda",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      